// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__MEpnh","FooterRow":"Footer_FooterRow__teyA3","FooterRowFill":"Footer_FooterRowFill__EcpdP"};